import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  deleteAddressChangeReasonsById,
  deleteDeliveryReasonsById,
  deleteHoldReasonsById,
  deletePickupReasonsById,
  exportAddressChangeReasons,
  exportDeliveryReasons,
  exportHoldReasons,
  exportPickupReasons,
  getAddressChangeApplicableTo,
  getAddressChangeTypeScope,
  getAddressChangeReasons,
  getAddressChangeReasonsById,
  getDeliveryEventCategory,
  getDeliveryReasons,
  getDeliveryReasonsById,
  getHoldReasons,
  getHoldReasonsById,
  getOpsCategory,
  getOpsFailureType,
  getPickupCategory,
  getPickupEventCategory,
  getPickupReasons,
  getPickupReasonsById,
  postAddressChangeReasons,
  postDeliveryReasons,
  postHoldReasons,
  postPickupReasons,
  updateAddressChangeReasonsById,
  updateDeliveryReasonsById,
  updateHoldReasonsById,
  updatePickupReasonsById,
  filterAddressChangeReasons,
} from "../../services/Reasons/Reason_services";

const initialValues = {
  pickupReasonsData: [],
  deliveryReasonsData: [],
  holdReasonsData: [],
  addressChangeReasonsData: [],
};

let reasonStore = (set) => ({
  ...initialValues,
  getPickupReasons: async (params) => {
    const response = await getPickupReasons(params);
    set({ pickupReasonsData: response });
    return response;
  },
  postPickupReasons: async (params) => {
    const response = await postPickupReasons(params);
    return response;
  },
  updatePickupReasonsById: async (params, data) => {
    const response = await updatePickupReasonsById(params, data);
    return response;
  },
  deletePickupReasonsById: async (params) => {
    const response = await deletePickupReasonsById(params);
    return response;
  },
  getPickupReasonsById: async (params) => {
    const response = await getPickupReasonsById(params);
    return response;
  },
  exportPickupReasons: async (params) => {
    const response = await exportPickupReasons(params);
    return response;
  },
  getPickupCategory: async () => {
    const response = await getPickupCategory();
    return response;
  },
  getPickupEventCategory: async () => {
    const response = await getPickupEventCategory();
    set({ OpsEventData: response });
    return response;
  },
  getDeliveryEventCategory: async () => {
    const response = await getDeliveryEventCategory();
    set({ OpsDeliveryEventData: response });
    return response;
  },
  getOpsCategory: async () => {
    const response = await getOpsCategory();
    set({ OpsCategoryData: response });
    return response;
  },
  getOpsFailureType: async () => {
    const response = await getOpsFailureType();
    set({ OpsFailureData: response });
    return response;
  },
  getDeliveryReasons: async (params) => {
    const response = await getDeliveryReasons(params);
    set({ deliveryReasonsData: response });
    return response;
  },
  postDeliveryReasons: async (params) => {
    const response = await postDeliveryReasons(params);
    return response;
  },
  updateDeliveryReasonsById: async (params, data) => {
    const response = await updateDeliveryReasonsById(params, data);
    return response;
  },
  deleteDeliveryReasonsById: async (params) => {
    const response = await deleteDeliveryReasonsById(params);
    return response;
  },
  getDeliveryReasonsById: async (params) => {
    const response = await getDeliveryReasonsById(params);
    return response;
  },
  exportDeliveryReasons: async (params) => {
    const response = await exportDeliveryReasons(params);
    return response;
  },
  getHoldReasons: async (params) => {
    const response = await getHoldReasons(params);
    set({ holdReasonsData: response });
    return response;
  },
  postHoldReasons: async (params) => {
    const response = await postHoldReasons(params);
    return response;
  },
  updateHoldReasonsById: async (params,data) => {
    const response = await updateHoldReasonsById(params,data);
    return response;
  },
  deleteHoldReasonsById: async (params) => {
    const response = await deleteHoldReasonsById(params);
    return response;
  },
  getHoldReasonsById: async (params) => {
    const response = await getHoldReasonsById(params);
    return response;
  },
  exportHoldReasons: async (params) => {
    const response = await exportHoldReasons(params);
    return response;
  },
  getAddressChangeReasons: async (params) => {
    const response = await getAddressChangeReasons(params);
    set({ addressChangeReasonsData: response });
    return response;
  },
  postAddressChangeReasons: async (params) => {
    const response = await postAddressChangeReasons(params);
    return response;
  },
  updateAddressChangeReasonsById: async (params, data) => {
    const response = await updateAddressChangeReasonsById(params, data);
    return response;
  },
  deleteAddressChangeReasonsById: async (params) => {
    const response = await deleteAddressChangeReasonsById(params);
    return response;
  },
  getAddressChangeReasonsById: async (params) => {
    const response = await getAddressChangeReasonsById(params);
    return response;
  },
  exportAddressChangeReasons: async (params) => {
    const response = await exportAddressChangeReasons(params);
    return response;
  },
  getAddressChangeApplicableTo: async () => {
    const response = await getAddressChangeApplicableTo();
    set({ addressChangeApplicableToData: response });
    return response;
  },
  getAddressChangeTypeScope: async () => {
    const response = await getAddressChangeTypeScope();
    set({ addressChangeTypeScopeData: response });
    return response;
  },
   filterAddressChangeReasons: async (params) => {
    const response = await filterAddressChangeReasons(params);
    set({ addressChangeReasonsData: response });
    return response;
  },
  //hubs
  exportDeliveryRequests: async (params) => {
    const response = await exportDeliveryReasons(params);
    return response;
  },
});

reasonStore = devtools(reasonStore);

export const useReasonStore = create(reasonStore);
